import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  ConsentTypesIcon,
  ConsentPublicationIcon,
} from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = () => {

  const data = [
    {
      name: getLocalizedString("consentTypes"),
      icon: <ConsentTypesIcon />,
      path: paths.consentTypes,
    },
    {
      name: getLocalizedString("consentPublication"),
      icon: <ConsentPublicationIcon />,
      path: paths.consentPublication,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("consentsScreenSelector")}
      data={data}
    />
  );
}

export default Index;
